import { vi } from 'vitest';

export const createMockComponent = (componentName: string, testId: string) => {
  return vi.fn(props => {
    const {
      children,
      ['data-testid']: componentTestId,
      ...restOfProps
    } = props;

    return (
      <span
        data-mock={componentName}
        data-testid={componentTestId || testId}
        {...restOfProps}
      >
        {children ? children : `Mock ${componentName}`}
      </span>
    );
  });
};
